const DEFAULT_HELLO_EMAIL = 'hello@oppfoundry.com';
const DEFAULT_SUPPORT_EMAIL = 'support@oppfoundry.com';
const DEFAULT_SALES_EMAIL = 'sales@oppfoundry.com';

const env = import.meta.env;

/**
 * Centralized email address configuration sourced from Vite env vars.
 * Defaults keep the UI working in development even if env values are missing.
 */
export const emailAddresses = {
  hello: (env.VITE_HELLO_EMAIL as string | undefined) || DEFAULT_HELLO_EMAIL,
  support: (env.VITE_SUPPORT_EMAIL as string | undefined) || DEFAULT_SUPPORT_EMAIL,
  sales: (env.VITE_SALES_EMAIL as string | undefined) || DEFAULT_SALES_EMAIL,
} as const;

export type EmailKind = keyof typeof emailAddresses;

export function getEmail(kind: EmailKind): string {
  return emailAddresses[kind];
}
